export default {
  taskCenterV2: '/v3/grow/taskCenterV2',
  taskCenterInfo: '/v3/grow/taskCenter',
  getPackageAward: '/v3/grow/getPackageAward', // 领取任务包奖励
  getSubTaskAward: '/v3/grow/getSubTaskAward', // 领取子任务奖励
  getTodayData: '/v3/grow/getTodayData' // 查询今日统计数据
}
